import React from "react";
import { useTranslation } from "react-i18next";
import { Event, RoomPlayer, RoomPlayerAction, RoomPlayerState } from "@uno/protocol";
import { AppContext } from "context";
import useStoreRoom from "store/useStoreRoom";
import useStoreRoomPlayer from "store/useStoreRoomPlayer";
import useHaptic from "hook/useHaptic";

const SwapTarget = ({ roomPlayer }: { roomPlayer: RoomPlayer }) => {
    const { t } = useTranslation();
    const { socket } = React.useContext(AppContext);
    const roomId = useStoreRoom(state => state.room?.id);
    const isChoosing = useStoreRoomPlayer(state => state.roomPlayer?.action === RoomPlayerAction.ChoosingSwapTarget);
    const haptic = useHaptic();

    const handleClick = React.useCallback(() => {
        haptic();
        socket?.emit(Event.RoomPlayerChooseSwapTarget, { roomId, targetId: roomPlayer.player.id });
    }, [haptic, socket, roomId, roomPlayer.player.id]);

    if(!isChoosing || roomPlayer.state === RoomPlayerState.Abandoned) {
        return null;
    }

    return (
        <button
            type="button"
            onClick={handleClick}
            aria-label={t("room.swap.with", { name: roomPlayer.player.username })}
            className="absolute -inset-1.5 z-[30] rounded-full border-4 border-yellow-300 shadow-[0_0_18px_rgba(253,224,71,0.8)] animate-pulse cursor-pointer pointer-events-auto"
        ></button>
    );
};

export default SwapTarget;
